import { render, staticRenderFns } from "./check_mobile.vue?vue&type=template&id=2caf4f7f&scoped=true&"
import script from "./check_mobile.vue?vue&type=script&lang=js&"
export * from "./check_mobile.vue?vue&type=script&lang=js&"
import style0 from "./check_mobile.vue?vue&type=style&index=0&id=2caf4f7f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2caf4f7f",
  null
  
)

export default component.exports